import React from 'react';
import { ReactComponent as FileDownloadIcon } from './file-download-solid.svg';

const AttachmentsSection = (props) => {
  return (
    <>
      <h2>Attachments</h2>
      <ul className="attachments-list">
        {props.attachments.map((v, idx) => (
          <li key={`attch-${idx}`}>
            <FileDownloadIcon className="download-icon" />
            <a href={v.filename} key={`attachment-${idx}`}>
              {v.title ?? v.filename}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};

export default AttachmentsSection;
